import { BarChart3, CheckCircle2 } from "lucide-react";
import { useTranslation } from "react-i18next";
import { REPORT_INCLUDES_ITEMS } from "../consts/steps";

export function ExportInsightsReportIncludes() {
  const [translate] = useTranslation(["insights"]);
  return (
    <div className="space-y-3">
      <div className="flex items-center gap-2">
        <BarChart3 className="h-4 w-4 text-primary" />
        <h4 className="font-medium">
          {translate("export-insights-report-includes-title")}
        </h4>
      </div>

      <div className="grid grid-cols-1 gap-2 ml-6">
        {REPORT_INCLUDES_ITEMS.map((item) => (
          <div
            key={item}
            className="flex items-center gap-2 text-sm text-muted-950"
          >
            <CheckCircle2 className="h-3 w-3 text-green-500" />
            {translate(item)}
          </div>
        ))}
      </div>
    </div>
  );
}
